import { ToggleGroup as ToggleGroupPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const ToggleGroupItem = ({
  className,
  ...props
}: ComponentProps<typeof ToggleGroupPrimitive.Item>) => (
  <ToggleGroupPrimitive.Item
    data-slot="toggle-group-item"
    className={cn(
      "inline-flex min-h-8 cursor-pointer items-center justify-center gap-1.5 text-[13px] whitespace-nowrap text-foreground-soft transition-colors outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-accent/60 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:font-semibold data-[state=on]:text-accent-foreground",
      "group-data-[variant=segment]/toggle-group:rounded-md group-data-[variant=segment]/toggle-group:px-3 group-data-[variant=segment]/toggle-group:data-[state=on]:bg-accent",
      "group-data-[variant=pill]/toggle-group:rounded-full group-data-[variant=pill]/toggle-group:border group-data-[variant=pill]/toggle-group:border-border group-data-[variant=pill]/toggle-group:bg-surface group-data-[variant=pill]/toggle-group:px-2.5 group-data-[variant=pill]/toggle-group:hover:border-border-strong group-data-[variant=pill]/toggle-group:data-[state=on]:border-accent group-data-[variant=pill]/toggle-group:data-[state=on]:bg-accent",
      className,
    )}
    {...props}
  />
);
